<!--suppress CssUnusedSymbol, CssInvalidAtRule -->
<template>
    <framed-layout no-padding>

        <template #center>
            <steps-progress
                :active="1"
                :steps="['Võimalik meeskond', 'Projektijuhi valimine', 'Lepingu sõlmimine']"
            ></steps-progress>
        </template>

        <template #right>
            <router-link to="/projects" class="btn-circle" @click.native="clearProject()">
                <i class="text-xl text-blue-500 pi pi-times"></i>
            </router-link>
        </template>

        <Dialog :visible.sync="confirmDialog" modal :closable="true">
            <div class="max-w-lg p-4 text-center md:p-8">
                <icon name="help" width="119" height="119" vbWidth="119" vbHeight="119" stroke="none" class="mb-8 md:mb-12" />
                <h3 class="mb-4 text-2xl font-semibold">Oled kindel, et soovid eemaldada valdkonna {{ toRemoveTitle }}?</h3>
                <p>
                    Valdkondi eemaldades peab olema teiepoolne asendus. Vastasel juhul projekt ei toimi ja me ei saa
                    garanteerida tööde teostamist. Valdkondi eemaldades saad projekti käigus neid alati tagasi lisada.
                </p>

                <button class="w-64 mt-8 text-white uppercase bg-orange-400 btn md:mt-12" @click="confirmAreaRemove">
                    Kinnitan
                </button>
            </div>
        </Dialog>

        <Dialog :visible.sync="confirmTeamLeadDialog" modal :closable="true">
          <div class="max-w-lg p-4 text-center md:p-8">
            <icon name="help" width="119" height="119" vbWidth="119" vbHeight="119" stroke="none" class="mb-8 md:mb-12" />
            <h3 class="mb-4 text-2xl font-semibold">Oled kindel, et soovid eemaldada valdkonna {{ toRemoveTitle }}?</h3>
            <p>
              Projektijuhi eemaldamisel olete ise automaatselt projektijuhi rollis ning kogu projekti suhtlus ja asjaajamine käib läbi Teie.
              Saate vajadusel kutsuda projekti ka abistavaid projektijuhte.
            </p>

            <button class="w-64 mt-8 text-white uppercase bg-orange-400 btn md:mt-12" @click="confirmTeamLeadRemove">
              Kinnitan
            </button>
          </div>
        </Dialog>

        <div class="absolute flex flex-wrap justify-between w-full h-full">
            <div
                v-if="$root.$data.isMobile"
                class="relative z-10 flex justify-center w-full p-4 bg-gray-100 bg-opacity-75"
            >
                <button class="inline-flex items-center" @click="openSidebar">
                    <i
                        class="flex items-center justify-center w-6 h-6 mr-2 text-xs text-white bg-blue-500 rounded-full pi pi-bars"
                    ></i>
                    <span>Projekti lähteandmed</span>
                </button>
            </div>

            <div class="w-full h-full overflow-hidden outline-none"
                 :class="$root.$data.isMobile ? 'md:w-full lg:w-full' : 'md:w-1/2 lg:w-4/6'">
                <svg height="0" width="0">
                    <clipPath id="hexagon-clip" clipPathUnits="objectBoundingBox">
                        <path
                            d="M 0.274 0 H 0.728 C 0.744 0 0.758 0.009 0.766 0.024 L 0.995 0.472 c 0.006 0.015 0.006 0.033 0 0.049 l -0.228 0.452 C 0.759 0.989 0.744 0.999 0.727 0.999 H 0.275 C 0.258 0.999 0.243 0.989 0.235 0.973 L 0.007 0.523 C -0.0015 0.508 -0.0015 0.49 0.007 0.474 L 0.235 0.024 c 0.008 -0.016 0.023 -0.024 0.039 -0.024"
                        ></path>
                    </clipPath>
                </svg>

                <div v-if="hexGrid.length > 0" id="panZoom" class="hex-grid">
                    <!-- START -->

                    <!-- 1 -->
                    <div v-for="(hexagon) in hexGrid.filter(hg => AreaType.PRIMARY === hg.area.areaType.id)" :key="hexagon.area.id" :ref="'hex-' + hexagon.area.id"
                         class="hex-grid__item">
                        <div class="hex-grid__content">
                            <button v-if="Area.PROJECT_MANAGER !== hexagon.area.id" class="toggle-team" @click="toggleTeam(hexagon.area.id)">
                                <span class="toggle-team__icon pi"></span>
                            </button>
                            <button v-else class="toggle-team" @click="toggleTeamLead(hexagon.area.id)">
                              <span class="toggle-team__icon pi"></span>
                            </button>

                            <div class="hex-grid__inner-content">
                                <h3 class="mb-1 font-semibold">{{ hexagon.area.name }}</h3>
                                <p class="text-sm font-semibold">{{ getAreaPrice(hexagon.area.id) | splitNumber }} € / {{ getAreaTaskCount(hexagon.area.id) }} ÜL</p>

                                <div class="flex mt-5 -ml-4">
                                    <template v-for="(member, h) in hexagon.team">
                                        <div
                                            v-if="member.image === null && member.subtitle !== null"
                                            :key="member.id"
                                            @click="showProfile(member.id)"
                                            v-tooltip.top="
                                                '<div class=\'p-2 flex items-center\'>' +
                                                  '<div class=\'w-8 h-8 rounded-full mr-3 bg-blue-500 text-white flex items-center justify-center font-semibold text-xs\'>' + memberName(member)  + '</div>' +
                                                  '<div>' +
                                                    '<h5 class=\'text-xs font-semibold\'>' + member.name + rating(member.rating) + '</h5>' +
                                                    '<p class=\'text-xxs\'>' + member.subtitle + '</p>' +
                                                   '</div>' +
                                                '</div>'
                                              "
                                            :style="'z-index:' + (10-h)"
                                            escape="false"
                                            class="flex items-center justify-center w-12 h-12 -mr-4 text-sm font-semibold text-white bg-blue-500 border-white rounded-full cursor-default border-3"
                                        >
                                            {{ memberName(member) }}
                                        </div>
                                        <div
                                            v-else-if="member.image === null && member.subtitle === null"
                                            :key="member.id"
                                            @click="showProfile(member.id)"
                                            v-tooltip.top="
                                                '<div class=\'p-2 flex items-center\'>' +
                                                  '<div class=\'w-8 h-8 rounded-full mr-3 bg-blue-500 text-white flex items-center justify-center font-semibold text-xs\'>' + memberName(member)  + '</div>' +
                                                    '<div>' +
                                                      '<h5 class=\'text-xs font-semibold\'>' + member.name + rating(member.rating) + '</h5>' +
                                                    '</div>' +
                                                 '</div>'
                                               "
                                            :style="'z-index:' + (10-h)"
                                            escape="false"
                                            class="flex items-center justify-center w-12 h-12 -mr-4 text-sm font-semibold text-white bg-blue-500 border-white rounded-full cursor-default border-3"
                                        >
                                          {{ memberName(member) }}
                                        </div>
                                        <div v-else :key="member.id">
                                          <img
                                              v-tooltip.top="
                                                '<div class=\'p-2 flex items-center\'><img src=\'' + member.image + '\' class=\'w-8 h-8 rounded-full mr-3\'/>' +
                                                   '<div>' +
                                                     '<h5 class=\'text-xs font-semibold\'>' + member.name + rating(member.rating) + '</h5>' +
                                                     '<p class=\'text-xxs\'>' + member.subtitle + '</p>' +
                                                    '</div>' +
                                                 '</div>'
                                               "
                                              :src="member.image"
                                              :style="'z-index:' + (10-h)"
                                              escape="false"
                                              class="w-12 h-12 -mr-4 bg-gray-300 border-white rounded-full cursor-default border-3"
                                          />
                                        </div>
                                    </template>
                                </div>

                                <div v-if="hexagon.phases && honeySelection.find(a => a.id === hexagon.area.id)" class="flex flex-wrap justify-center mt-4">
                                    <div
                                        v-for="(phase) in hexagon.phases"
                                        :key="phase.id"
                                        class="flex items-center px-2 my-1 p-field-checkbox"
                                    >
                                        <checkbox
                                            :id="'phase' + hexagon.area.id + phase.id"
                                            :input-id="'phase' + hexagon.area.id + phase.id"
                                            name="honeyPhases"
                                            :value="phase"
                                            v-model="honeySelection.find(a => a.id === hexagon.area.id).phases"
                                            class="p-checkbox--smol"
                                            @input="checkPhase(phase)"
                                        />
                                        <label :for="'phase' + hexagon.area.id + phase.id" class="ml-1 text-xs">{{ phase.name }}</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="hex-grid__item">
                      <div class="hex-grid__content">
                        <button class="toggle-team-info"
                                v-tooltip.top="
                                    '<div>' +
                                      'Lisateenuseid saab lisada paremalt valikute alt' +
                                    '</div>'">
                          <span class="toggle-team__icon pi pi-info-circle"></span>
                        </button>

                        <div class="hex-grid__inner-content">
                          <h3 class="mb-1 font-semibold">Lisateenused</h3>
                          <p class="text-sm font-semibold">{{ getSecondaryAreaPriceTotal() | splitNumber }} € / {{ getSecondaryAreaTaskCountTotal() }} ÜL</p>


                          <div class="flex flex-wrap justify-center mt-4">
                            <div v-for="(extArea) in hexGrid.filter(hg => AreaType.SECONDARY === hg.area.areaType.id && areasEnabled.includes(hg.area.id))"
                                 :key="extArea.area.id"
                                 class="flex items-center px-2 my-1 p-field-checkbox">
                              <checkbox
                                  :id="extArea.area.id"
                                  :input-id="extArea.area.id"
                                  name="extra_service"
                                  class="p-checkbox--smol"
                                  :value="extArea.area.id"
                                  v-model="areasEnabled"
                                  @input="checkSecondaryArea(extArea.area.id)"
                              />
                              <label :for="extArea.area.id" class="ml-1 text-xs uppercase">{{ extArea.area.shortName }}</label>
                            </div>
                          </div>


                        </div>
                      </div>
                    </div>

                    <!-- END -->
                </div>
            </div>

            <div class="w-full h-full rounded-tr-lg md:w-1/2 lg:w-2/6 md:rounded-tr-xxl">
                <component
                    :is="$root.$data.isMobile ? 'sidebar' : 'div'"
                    :visible.sync="sidebar"
                    position="right"
                    :class="{ 'h-full relative': !$root.$data.isMobile }"
                    class="overflow-y-auto"
                >
                    <div
                        :class="{ 'absolute top-0': !$root.$data.isMobile }"
                        class="px-6 pt-12 pb-6 overflow-y-auto md:px-8 md:py-10"
                        style="height: calc(100% - 230px)"
                    >
                        <h3 class="mb-8 text-xl font-semibold md:text-2xl md:mb-12">Projekti lähteandmed</h3>

                        <div class="mb-8 p-float-label">
                            <dropdown
                                id="type"
                                v-model="type"
                                :options="buildingTypes"
                                optionLabel="name"
                                class="w-full text-gray-900"
                                @change="changeProject"
                            />
                            <label for="type" class="text-blue-500 uppercase">Hoone liik</label>
                        </div>

                        <div class="mb-8 p-inputgroup">
                            <div class="p-float-label">
                                <input-number
                                    id="size"
                                    placeholder=" "
                                    v-model="size"
                                    :use-grouping="false"
                                    class="w-full"
                                    autocomplete="off"
                                    @input="changeProject"
                                />
                                <label for="size" class="text-blue-500 uppercase">Suletud netopind</label>
                            </div>

                            <div class="p-inputgroup-addon">m<sup>2</sup></div>
                        </div>

                        <div class="mb-8 p-float-label">
                          <dropdown
                              id="type"
                              v-model="business"
                              :options="businesses"
                              optionLabel="name"
                              class="w-full text-gray-900"
                          />
                          <label for="type" class="text-blue-500 uppercase">Ettevõte</label>
                        </div>

                        <div class="mb-6">
                          <h5 class="mb-4 text-sm text-blue-500 uppercase">Kommentaar</h5>
                          <textarea
                              v-model="comment"
                              class="w-full"
                              placeholder="Kommentaar..."
                              rows="2"
                              maxlength="500"
                          />
                        </div>

                        <div class="mb-6">
                            <h5 class="mb-4 text-sm text-blue-500 uppercase">Seisukord</h5>
                            <select-button v-model="condition" :options="conditions" />
                        </div>

                        <div class="mb-6">
                            <h5 class="mb-4 text-sm text-blue-500 uppercase">Ehitusluba</h5>
                            <select-button v-model="permission" :options="permissions" />
                        </div>

                        <div class="mb-6">
                          <h5 class="mb-4 text-sm text-blue-500 uppercase">Vali soovitud lisateenused</h5>

                          <div v-for="(secArea) in hexGrid.filter(hg => AreaType.SECONDARY === hg.area.areaType.id)" :key="secArea.area.id" class="mb-3 p-field-checkbox">
                            <checkbox
                                :id="secArea.area.id"
                                :input-id="secArea.area.id"
                                name="extra_service"
                                :value="secArea.area.id"
                                v-model="areasEnabled"
                                @input="checkSecondaryArea(secArea.area.id)"
                            />
                            <label :for="secArea.area.id" class="ml-3 text-sm">
                              {{ secArea.area.name }}
                              <span v-if="getTotalAreaPrice(secArea.area.id) === 0" class="text-red-500">*</span>
                            </label>
                          </div>

                          <span class="text-sm"><span class="text-red-500">*</span> Hinnastab töövõtja, hind lisandub töömahu selgumisel</span>

                        </div>

                        <div class="mt-12 mb-8 p-float-label">
                            <dropdown
                                id="energyclass"
                                v-model="energyclass"
                                :options="energyTypes"
                                class="w-full text-gray-900"
                            />
                            <label for="energyclass" class="text-blue-500 uppercase">Energiaklass</label>
                        </div>

                        <div class="mb-8">
                            <h5 class="mb-4 text-sm text-blue-500 uppercase">Vali soovitud välisvõrgud</h5>

                            <div class="flex flex-wrap">
                                <div
                                    v-for="(external, i) in externalStuffOptions"
                                    :key="i"
                                    class="w-1/2 mb-3 p-field-checkbox"
                                >
                                    <checkbox
                                        :id="external + i"
                                        :input-id="external + i"
                                        name="external"
                                        :value="external"
                                        v-model="externalStuff"
                                    />
                                    <label :for="external + i" class="ml-3 text-sm">{{ external }}</label>
                                </div>
                            </div>
                        </div>

                        <div class="mb-10 p-float-label">
                            <input-number
                                id="groundFloors"
                                placeholder=" "
                                v-model="groundFloors"
                                :use-grouping="false"
                                class="w-full"
                                @input="changeProject"
                            />
                            <label for="groundFloors" class="text-blue-500 uppercase">Maa-pealseid korruseid</label>
                        </div>

                        <div class="mb-10 p-float-label">
                            <input-number
                                id="undergroundFloors"
                                placeholder=" "
                                v-model="undergroundFloors"
                                :use-grouping="false"
                                class="w-full"
                            />
                            <label for="undergroundFloors" class="text-blue-500 uppercase">Maa-aluseid korruseid</label>
                        </div>

                       <div class="mb-6">
                         <label class="text-blue-500 uppercase">Aadress</label>
                         <div id="InAadressDiv" class="p-component p-inputnumber-input"></div>
                       </div>

                        <div class="mb-10 p-float-label">
                            <calendar
                                id="startDate"
                                v-model="startDate"
                                dateFormat="dd.mm.yy"
                                :min-date="new Date()"
                                :manual-input="false"
                                show-icon
                                icon="pi pi-calendar-plus"
                                :locale="$root.$data.et"
                                placeholder=" "
                                class="w-full p-datepicker--dense"
                            />
                            <label for="startDate" class="text-blue-500 uppercase">Projekti soovitud algus</label>
                        </div>
                    </div>

                    <div
                        :class="{ 'absolute bottom-0': !$root.$data.isMobile }"
                        class="w-full px-6 py-5 bg-blue-400 rounded-t-lg md:px-8 md:rounded-t-xxl"
                        :style="!$root.$data.isMobile ? 'height: 230px;' : ''"
                    >
                        <p class="text-sm uppercase">Projekti hinnanguline maksumus ({{taskSum}} ülesannet)</p>
                        <p class="text-sm uppercase">Hind sisaldab teenustasu {{ serviceFee }}%</p>
                        <p class="text-sm uppercase">Hinnale lisandub käibemaks</p>

                        <p class="mb-2 text-4xl font-semibold md:text-5xl">{{ priceSum | splitNumber }} €</p>

                        <button
                            @click="showSaveDialog"
                            class="w-full uppercase bg-white btn"
                        >Saada päring spetsialistidele
                        </button>
                    </div>
                </component>
            </div>
        </div>

        <Dialog :visible.sync="showModal" :closable="true" :dismissableMask="true" modal class="w-2/3">
          <profile :member-id="this.memberId"/>
        </Dialog>


        <Dialog :visible.sync="saveDialog" modal :closable="true">
          <div class="max-w-lg p-4 text-center md:p-8">
            <icon name="help" width="119" height="119" vbWidth="119" vbHeight="119" stroke="none" class="mb-8 md:mb-12" />
            <h3 class="mb-4 text-2xl font-semibold">
              Kinnitan, et soovin projekteerijatele projekti pakkumise välja saata. Spetsialistid saavad hinnapakkumise koos sinu poolt sisestatud lähteülesandega.
            </h3>
            <button class="w-64 mt-8 text-white uppercase bg-blue-400 btn md:mt-12" ref="saveButton" @click="save()">
              Kinnitan
            </button>
            <button class="w-64 mt-8 text-white uppercase bg-orange-400 btn md:mt-12" @click="cancelSave()">
              Loobun
            </button>
          </div>
        </Dialog>

        <Dialog :visible.sync="loginDialog" modal :closable="true">
          <div class="max-w-lg p-4 text-center md:p-8">
            <icon name="help" width="119" height="119" vbWidth="119" vbHeight="119" stroke="none" class="mb-8 md:mb-12" />
            <h3 class="mb-4 text-2xl font-semibold">Projekti esitamiseks pead olema sisse logitud</h3>
            <button class="w-64 mt-8 text-white uppercase bg-blue-400 btn md:mt-12" @click="register()">
              Registreeri
            </button>
            <button class="w-64 mt-8 text-white uppercase bg-blue-400 btn md:mt-12" @click="login()">
              Logi sisse
            </button>
            <button class="w-64 mt-8 text-white uppercase bg-orange-400 btn md:mt-12" @click="cancelLogin()">
              Loobun
            </button>
          </div>
        </Dialog>

    </framed-layout>
</template>

<script>
// https://github.com/anvaka/panzoom
import panzoom from 'panzoom'
import FramedLayout from './../../Layouts/FramedLayout'
import Profile from '../../components/Profile';
import {mapGetters} from "vuex";
import {Phase} from "./../../utils/phase";
import {Area} from "@/utils/area";
import {getBusinesses} from "../../store/user.api"
import {AreaType} from "@/utils/area.type";
import {getStep1, save} from "@/store/project.api";

export default {
    components: {
      Profile,
      FramedLayout
    },
    computed: {
      AreaType() {
        return AreaType
      },
      Area() {
        return Area
      },
      ...mapGetters({
        user: 'global/user',
        isLoggedIn: 'global/isLoggedIn',
        project: 'global/project',
        hasProject: 'global/hasProject'
      }),
      Phase() {
        return Phase;
      },
      priceSum() {
        return this.priceWithServiceFee(this.hexGrid.filter(hg => this.areasEnabled.includes(hg.area.id))
        .flatMap(hg => hg.phases.filter(hp => this.phasesEnabled.includes(hp.id)))
        .map(p => p.price)
        .reduce((a, b) => a + b, 0));
      },
      taskSum() {
        return this.hexGrid.filter(hg => this.areasEnabled.includes(hg.area.id))
        .flatMap(hg => hg.phases.filter(hp => this.phasesEnabled.includes(hp.id)))
        .map(p => p.taskCount)
        .reduce((a, b) => a + b, 0);
      },
      secondaryAreasMaxPhase() {
        return this.honeySelection === 0 ? 0 : this.honeySelection.filter(area => {
          let a = this.hexGrid.filter(hg => hg.area.id === area.id)[0].area;
          console.log('area')
          console.log(area)
          console.log('a.areaType.id === AreaType.PRIMARY')
          console.log(a.areaType.id === AreaType.PRIMARY)
          console.log('this.areasEnabled.includes(a.id)')
          console.log(this.areasEnabled.includes(a.id))
          return a.areaType.id === AreaType.PRIMARY && this.areasEnabled.includes(a.id);
        })
        .flatMap(area => area.phases.filter(ap => ap.phaseId !== Phase.RESEARCH && ap.phaseId !== Phase.SKETCH))
        .reduce((prev, current) => (prev && prev > current.phaseId) ? prev : current.phaseId, 2);
      },
    },
    data() {
        return {
            areasEnabled: [],
            buildingTypes: [],
            businesses: [
              {
                id: null,
                name: 'Eraklient',
                code: 0,
              }
            ],
            business: null,
            hexGrid: [],
            serviceFee: null,
            initialSize: null,
            initialType: {},
            phasesEnabled: [],

            pan: null,
            confirmDialog: false,
            hasSeenConfirmDialog: false,
            confirmTeamLeadDialog: false,
            hasSeenConfirmTeamLeadDialog: false,
            toRemove: null,
            toRemoveId: null,
            toRemoveTitle: '',
            sidebar: false,
            size: 100,
            comment: null,
            type: [],
            condition: null,
            conditions: ['Uus', 'Rekonstruktsioon'],
            permission: null,
            permissions: ['Olemas', 'Vaja taotleda'],
            services: [],
            energyclass: null,
            energyTypes: ['A - väga hea', 'B', 'C', 'D - pole oluline'],
            externalStuff: ['Side', 'Gaas', 'Vesi', 'Kanal', 'Sadevesi', 'Elekter'],
            externalStuffOptions: ['Side', 'Gaas', 'Vesi', 'Kanal', 'Sadevesi', 'Elekter'],
            groundFloors: null,
            undergroundFloors: null,
            address: null,
            startDate: null,
            honeySelection: [
                {
                  id: null,
                  phases: []
                }
            ],
            areaMembers: [],
            leads: [],
            showModal: false,
            memberId: null,
            saveDialog: false,
            loginDialog: false,
            prevSecondaryAreaMaxPhase: Phase.PRE,
        }
    },
    created() {
      let addressScript = document.createElement('script')
      addressScript.setAttribute('src', 'https://inaadress.maaamet.ee/inaadress/js/inaadress.min.js?d=20220510')
      document.head.appendChild(addressScript);
    },
    async mounted() {
        if (this.$route.query?.type) {
          this.initialType = {
            id: this.$route.query?.type
          };
        }
        this.type = this.initialType

        if (this.$route.query?.size) {
          this.size = +this.$route.query?.size;
        }

        if (this.hasProject) {
          this.hexGrid = this.project.hexGrid;
          this.areasEnabled = this.project.areasEnabled;
          this.size = this.project.size;
          this.type = this.project.type;
          this.serviceFee = this.project.serviceFee;
          this.condition = this.project.condition;
          this.permission = this.project.permission;
          this.services = this.project.services;
          this.energyclass = this.project.energyclass;
          this.externalStuff = this.project.externalStuff;
          this.groundFloors = this.project.groundFloors;
          this.undergroundFloors = this.project.undergroundFloors;
          //this.address = this.project.address;
          this.startDate = this.project.startDate;
          this.comment = this.project.comment;
          this.leads = this.project.leads;
          this.honeySelection = this.project.honeySelection;
        }

        await this.changeProject();

        if (!this.$root.$data.isMobile) {
          this.loadAddressSearch();
        }

        const hex = document.getElementById('panZoom')
        const windowWidth = window.innerWidth
        let zoom = 1.0
        let minZoom = 1
        let maxZoom = 1

        if (windowWidth <= 1024) {
            zoom = 0.7
            minZoom = 0.35
        }

        if (windowWidth <= 480) {
            zoom = 0.35
        }

        this.pan = panzoom(hex, {
            minZoom: minZoom,
            maxZoom: maxZoom
        }).zoomAbs(0, 0, zoom)

        this.size = this.initialSize
        this.type = this.initialType

        if (!this.isLoggedIn) {
          this.business = this.businesses[0];
        } else {
          await getBusinesses().then((resp) => {
            this.businesses = resp.data;
            this.business = this.businesses.find(key => {
              return key.businessUserId === this.user.defaultBusinessUserId;
            });
          });
        }

        await this.mapToHoneySelection();
    },
    beforeDestroy() {
        if (this.pan !== undefined && this.pan !== null) {
            this.pan.dispose()
        }
    },
    methods: {
        showProfile(memberId) {
          if (this.isLoggedIn) {
            this.memberId = memberId;
            this.showModal = true;
          }
        },
        checkPhase(phase) {
          const index = this.phasesEnabled.indexOf(phase.id);
          if (index > -1) {
            this.phasesEnabled.splice(index, 1);
          } else {
            this.phasesEnabled.push(phase.id);
          }

          this.phasesProcessing();
        },
        phasesProcessing() {
          if (this.prevSecondaryAreaMaxPhase > this.secondaryAreasMaxPhase) {
            // remove phases
            this.honeySelection.forEach(area => {
                let selectedAreaPhases = area.phases;
                let hexArea = this.hexGrid.find(key => key.area.id === area.id && key.area.areaType.id === AreaType.SECONDARY);
                if (hexArea !== undefined && hexArea !== null) {
                if (hexArea.phases.length > 1 ) {
                  hexArea.phases
                  .forEach(phase => {
                    if (phase.phaseId > this.secondaryAreasMaxPhase) {
                      this.removePhases(selectedAreaPhases, phase);
                    }
                  });
                }
              }
            });

            this.prevSecondaryAreaMaxPhase = this.secondaryAreasMaxPhase;
          } else if (this.prevSecondaryAreaMaxPhase < this.secondaryAreasMaxPhase) {
            // add phases
            this.honeySelection.forEach(area => {
               let selectedAreaPhases = area.phases;
               let hexArea = this.hexGrid.find(key => key.area.id === area.id && key.area.areaType.id === AreaType.SECONDARY);
               if (hexArea !== undefined && hexArea !== null && this.areasEnabled.includes(hexArea.area.id)) {
                 hexArea.phases.forEach(phase => {
                   if (phase.phaseId <= this.secondaryAreasMaxPhase) {
                     this.addToSelectedAreaPhases(selectedAreaPhases, phase);
                     this.addToEnabledPhases(phase);
                  }
                });
               }
            });

            this.prevSecondaryAreaMaxPhase = this.secondaryAreasMaxPhase;
          }
        },
        checkSecondaryArea(areaId) {
          let isEnabled = this.areasEnabled.includes(areaId);

          this.honeySelection.forEach(area => {
            if (area.id === areaId) {
              let selectedAreaPhases = area.phases;

              let areaPhases = this.hexGrid.find(key => key.area.id === areaId).phases;
              if (areaPhases.length === 1) {
                if (isEnabled) {
                  this.addPhases(selectedAreaPhases, areaPhases[0]);
                } else {
                  this.removePhases(selectedAreaPhases, areaPhases[0]);
                }
              } else {
                areaPhases.forEach(phase => {
                  if (isEnabled) {
                    if (phase.phaseId === this.secondaryAreasMaxPhase || phase.phaseId < this.secondaryAreasMaxPhase) {
                      this.addPhases(selectedAreaPhases, phase);
                    }
                  } else {
                    this.removePhases(selectedAreaPhases, phase);
                  }
                });
              }
            }
          });
        },
        addPhases(selectedAreaPhases, phase) {
          this.addToSelectedAreaPhases(selectedAreaPhases, phase);
          this.addToEnabledPhases(phase);
        },
        removePhases: function (selectedAreaPhases, phase) {
          this.removeFromSelectedAreaPhases(selectedAreaPhases, phase);
          this.removeFromEnabledPhases(phase);
        },
        removeFromSelectedAreaPhases(selectedAreaPhases, phase) {
          const iSelectedAreaPhases = selectedAreaPhases.findIndex(p => p.id === phase.id);
          if (iSelectedAreaPhases > -1) {
            selectedAreaPhases.splice(iSelectedAreaPhases, 1);
          }
        },
        removeFromEnabledPhases(phase) {
          const iPhasesEnabled = this.phasesEnabled.indexOf(phase.id);
          if (iPhasesEnabled > -1) {
            this.phasesEnabled.splice(iPhasesEnabled, 1);
          }
        },
        addToSelectedAreaPhases(selectedAreaPhases, phase) {
          const iSelectedAreaPhases = selectedAreaPhases.findIndex(p => p.id === phase.id);
          if (iSelectedAreaPhases <= -1) {
            selectedAreaPhases.push(phase);
          }
        },
        addToEnabledPhases(phase) {
          const iPhasesEnabled = this.phasesEnabled.indexOf(phase.id);
          if (iPhasesEnabled <= -1) {
            this.phasesEnabled.push(phase.id);
          }
        },
        openSidebar() {
          this.sidebar = true;
          this.loadAddressSearch();
        },
        loadAddressSearch() {
          let _this = this;

          let inAadressScriptIsReady = false;

          var inAadress;
          let checkInterval = setInterval(function () {
            if (!inAadress) {
              inAadressScriptIsReady = true;
              clearInterval(checkInterval);
              if(document.getElementById("InAadressDiv")) {
                inAadress = new InAadress({"container":"InAadressDiv","mode":3,"ihist":"0","appartment":0,"lang":"et"});
                document.addEventListener('addressSelected', function(e){
                  if (e.detail.length >= 1) {
                    let a = e.detail[0];
                    _this.address = {
                      'lahiaadress': a.lahiaadress ? a.lahiaadress : null,
                      'liikluspind': a.liikluspind ? a.liikluspind : null,
                      'asustusyksus': a.asustusyksus ? a.asustusyksus : null,
                      'omavalitsus': a.omavalitsus ? a.omavalitsus : null,
                      'ads_oid': a.ads_oid,
                      'adr_id': a.adr_id,
                      'adob_id': a.adob_id,
                    }
                  }
                });
              }
            }
            return inAadressScriptIsReady;
          }, 500);
        },
        confirmRemove() {
          let idx = this.areasEnabled.indexOf(this.toRemoveId)

          if (idx !== -1) {
            this.areasEnabled.splice(idx, 1);
          }

          this.toRemove.classList.add('inactive')
          this.toRemove = null
          this.toRemoveTitle = ''
          this.toRemoveId = null
          this.phasesProcessing();
        },
        confirmAreaRemove() {
          this.confirmDialog = false;
          this.confirmRemove();
        },
        confirmTeamLeadRemove() {
          this.confirmTeamLeadDialog = false;
          this.confirmRemove();
        },
        toggleTeam(area_id) {
            let item = this.$refs['hex-' + area_id][0]

            if (item.classList.contains('inactive')) {
                // ADD
                item.classList.remove('inactive');
                this.areasEnabled.push(area_id);
                this.phasesProcessing();
            } else {
                // REMOVE
                this.toRemoveId = area_id
                this.toRemove = item
                this.toRemoveTitle = this.hexGrid.find((area) => area.area.id === area_id).area.name.toLowerCase()

                if (this.hasSeenConfirmDialog) {
                  this.confirmAreaRemove();
                } else {
                  this.confirmDialog = true
                }

                this.hasSeenConfirmDialog = true;
            }
        },
        toggleTeamLead(area_id) {
            let item = this.$refs['hex-' + area_id][0]

            if (item.classList.contains('inactive')) {
                // ADD
                item.classList.remove('inactive');
                this.areasEnabled.push(area_id);
                this.phasesProcessing();
            } else {
                // REMOVE
                this.toRemoveId = area_id
                this.toRemove = item
                this.toRemoveTitle = this.hexGrid.find((area) => area.area.id === area_id).area.name.toLowerCase()

                if (this.hasSeenConfirmTeamLeadDialog) {
                  this.confirmTeamLeadRemove();
                } else {
                  this.confirmTeamLeadDialog = true
                }

                this.hasSeenConfirmTeamLeadDialog = true;
            }
        },
        removeTeam(area_id) {
          let thisArea = this.hexGrid.find((hg) => hg.area.id === area_id)?.area;

          if (AreaType.PRIMARY === thisArea.areaType.id) {
            let item = this.$refs['hex-' + area_id][0]
            item.classList.add('inactive')
          }
        },
        async mapToHoneySelection() {
          let allAreas = (this.hexGrid).map(function (hexagon) {
            return hexagon.area.id
          })
          this.honeySelection = (this.hexGrid).map(function (hexagon) {
            return {id: hexagon.area.id, phases: hexagon.phases}
          })
          let areaDifference = allAreas.filter(x => !this.areasEnabled.includes(x))
          areaDifference.forEach((area_id) => {
            this.removeTeam(area_id)
          })

          this.honeySelection.forEach((area) => {
            area.phases = area.phases.filter(x => this.phasesEnabled.includes(x.id))
          });
        },
        async changeProject() {
          let config = {
            params: {
              size: this.size,
              type: this.type.id,
              areasEnabled: this.areasEnabled,
              phasesEnabled: this.honeySelection.length ?
                  this.honeySelection?.map(h => h.phases).reduce((p, c) => p.concat(c))?.map(h => h.id) :
                  null,
              honey: this.honeySelection,
              groundFloors: this.groundFloors
            }
          };
          const { data } = await getStep1(config);

            if (data) {
                this.areasEnabled = data?.areasEnabled;
                this.buildingTypes = data?.buildingTypes;
                this.hexGrid = data?.hexGrid;
                this.serviceFee = data?.serviceFee;
                this.initialSize = +data?.initialSize;
                this.initialType = data?.initialType;
                this.phasesEnabled = data?.phasesEnabled;
                this.leads = data?.leads;
                this.areaMembers = data?.hexGrid.map(hg => {
                  return {
                    area: hg.area,
                    idList: hg.team.map(t => t.id)
                  };
                })

                await this.mapToHoneySelection();
            }
        },
        showSaveDialog() {
          if (!this.isLoggedIn) {
            this.loginDialog = true;
            return;
          }

          if (this.address === null) {
            this.showToast('Palun vali aadress', 'warn');
            return;
          }

          if (this.startDate === null) {
            this.showToast('Palun vali projekti soovitud algus', 'warn');
            return;
          }
          this.saveDialog = true;
        },
        cancelLogin() {
          this.loginDialog = false;
        },
        register() {
          this.redirect('/register');
        },
        login() {
          this.redirect('/login');
        },
        redirect(path) {
          var projectData = {
            type: this.type,
            size: this.size,
            hexGrid: this.hexGrid,
            areasEnabled: this.areasEnabled,
            condition: this.condition,
            permission: this.permission,
            services: this.services,
            energyclass: this.energyclass,
            externalStuff: this.externalStuff,
            groundFloors: this.groundFloors,
            undergroundFloors: this.undergroundFloors,
            //address: this.address,
            startDate: this.startDate,
            comment: this.comment,
            leads: this.leads,
            honeySelection: this.honeySelection
          };
          this.$store.commit('global/setProject', projectData);
          this.$router.push(path);
        },
        cancelSave() {
          this.saveDialog = false;
        },
        save() {
            this.$refs.saveButton.classList.add('p-disabled');

            const payload = {
                //areas: this.areas,
                areasEnabled: this.areasEnabled,
                phasesEnabled: this.phasesEnabled,
                size: this.size,
                type: this.type,
                serviceFee: this.serviceFee,
                condition: this.condition,
                permission: this.permission,
                services: this.services,
                energyclass: this.energyclass,
                externalStuff: this.externalStuff,
                groundFloors: this.groundFloors,
                undergroundFloors: this.undergroundFloors,
                address: this.address,
                startDate: new Date(this.startDate.getTime() - this.startDate.getTimezoneOffset() * 60000),
                comment: this.comment,
                areaMembers: this.areaMembers,
                leads: this.leads,
                business: this.business
            };

            var honeyList = [];
            for (let i = 0; i < this.honeySelection.length; i++) {
              honeyList.push({ areaId: this.honeySelection[i].id, phases: this.honeySelection[i].phases });
            }
            payload["honey"] = honeyList;

            save(payload).then(async({ data }) => {
                this.$refs.saveButton.classList.remove('p-disabled');
                if (data.projectUserId) {
                  this.clearProject();
                  this.$router.push(`/project/sent`);
                  setTimeout(() => {
                    this.processAxiosPositiveResponse(data);
                  }, 100);
                } else {
                  this.showToast(data.toast, 'warn');
                }
            }, () => {
              this.$refs.saveButton.classList.remove('p-disabled');
            });
        },
      rating(rating) {
            return `<span class='ml-1 text text-blue-500 pi pi-star'></span><span class='ml-1 text-lg'>${rating}</span>`
      },

      memberName(member) {
          return member.name.split(' ').map((n) => n[0]).join('');
      },
      clearProject() {
        if (this.hasProject) {
          this.$store.commit('global/setProject', {});
        }
      },
      getAreaPrice(areaId) {
        return this.hexGrid.filter(hg => hg.area.id === areaId)
        .flatMap(hg => hg.phases.filter(hp => this.phasesEnabled.includes(hp.id)))
        .map(p => p.price)
        .reduce((a, b) => a + b, 0);
      },
      getSecondaryAreaPriceTotal() {
        return this.hexGrid.filter(hg => AreaType.SECONDARY === hg.area.areaType.id)
        .flatMap(hg => hg.phases.filter(hp => this.phasesEnabled.includes(hp.id)))
        .map(p => p.price)
        .reduce((a, b) => a + b, 0);
      },
      getTotalAreaPrice(areaId) {
        return this.hexGrid.filter(hg => hg.area.id === areaId)
        .flatMap(hg => hg.phases)
        .map(p => p.price)
        .reduce((a, b) => a + b, 0);
      },
      getAreaTaskCount(areaId) {
        return this.hexGrid.filter(hg => hg.area.id === areaId)
        .flatMap(hg => hg.phases.filter(hp => this.phasesEnabled.includes(hp.id)))
        .map(p => p.taskCount)
        .reduce((a, b) => a + b, 0);
      },
      getSecondaryAreaTaskCountTotal() {
        return this.hexGrid.filter(hg => AreaType.SECONDARY === hg.area.areaType.id)
        .flatMap(hg => hg.phases.filter(hp => this.phasesEnabled.includes(hp.id)))
        .map(p => p.taskCount)
        .reduce((a, b) => a + b, 0);
      },
      priceWithServiceFee(price) {
        return (price * (this.serviceFee / 100 + 1)).toFixed(0);
      }

    },
}
</script>

<style>

.inads-input {
  border: 2px solid #9ce1e9 !important;
  font-family: theme('fontFamily.sans') !important;
}

.inads-result  {
  border: 2px solid #9ce1e9 !important;
  font-family: theme('fontFamily.sans') !important;
}

.inads-result li:hover {
  background-color: #9ce1e9 !important;
  color: #000000 !important;
}

.inads_spinner:after {
  border-color: #9ce1e9 transparent #9ce1e9 transparent !important;
}

.inads-result >>> li >>> span{
  border: 2px solid #9ce1e9 !important;
  font-family: theme('fontFamily.sans') !important;
}

.inads-result >>> li >>> span{
  border: 2px solid #9ce1e9 !important;
  font-family: theme('fontFamily.sans') !important;
}

.inads-input-search{
  filter: brightness(0) saturate(100%) invert(44%) sepia(75%) saturate(2633%) hue-rotate(157deg) brightness(93%) contrast(101%) !important;
}

.inads-input-clear {
  filter: brightness(0) saturate(100%) invert(44%) sepia(75%) saturate(2633%) hue-rotate(157deg) brightness(93%) contrast(101%) !important;
}

:root {
    --hexScale: 1;
}
</style>

<style scoped lang="scss">
.p-sidebar {
    padding: 0;
}

textarea {
  @apply border-blue-300;
  @apply border-r-4;
  @apply border-2;
}

::v-deep .p-sidebar-close {
    @apply mr-4 mt-4;
}

.hex-grid {
    @apply p-4 cursor-move;

    --amount: 3;
    --counter: 1;

    position: absolute;
    width: 930px;
    display: grid;
    grid-template-columns: repeat(var(--amount), 1fr, 2fr) 1fr;
    grid-gap: 0 9%;

    @screen md {
        @apply p-6 relative;
    }
}

.hex-grid__item {
    position: relative;
    grid-column: 1 / span 3;
    grid-row: calc(var(--counter) + var(--counter)) / span 2;
    height: 0;
    padding-bottom: 90%;
    margin-top: 3%;
    margin-bottom: 3%;

    &::after {
        @apply transition duration-300;
    }

    &:nth-child(1) {
        --counter: 2;

        grid-column: #{2 + 2 - 1} / span 3;
        grid-row: calc(var(--counter) + var(--counter) - 1) / span 2;
        filter: drop-shadow(0 0 15px rgba(0, 0, 0, 0.08));
    }

    &:nth-child(2) {
        grid-column: #{1 + 1 - 1} / span 3;

        &::after {
            content: '';
            width: 80%;
            height: 6px;
            background: #fff;
            position: absolute;
            right: calc(-9% + 6px);
            bottom: calc(41% - 6px);
            z-index: 0;
            transform: rotateZ(33deg);
        }
    }

    &:nth-child(3) {
        grid-column: #{2 + 2 - 1} / span 3;
        grid-row: calc(var(--counter) + var(--counter) - 1) / span 2;

        &::after {
            content: '';
            width: 6px;
            height: 80%;
            background: #fff;
            position: absolute;
            left: 50%;
            bottom: -9%;
            z-index: 0;
        }
    }

    &:nth-child(4) {
        grid-column: #{3 + 3 - 1} / span 3;

        &::after {
            content: '';
            width: 80%;
            height: 6px;
            background: #fff;
            position: absolute;
            left: calc(-9% + 6px);
            bottom: calc(41% - 6px);
            z-index: 0;
            transform: rotateZ(-33deg);
        }
    }

    &:nth-child(5) {
        --counter: 2;

        &::after {
            content: '';
            width: 80%;
            height: 6px;
            background: #fff;
            position: absolute;
            right: calc(-9% + 6px);
            top: calc(41% - 6px);
            z-index: 0;
            transform: rotateZ(-33deg);
        }
    }

    &:nth-child(6) {
        --counter: 2;

        grid-column: #{3 + 3 - 1} / span 3;

        &::after {
            content: '';
            width: 80%;
            height: 6px;
            background: #fff;
            position: absolute;
            left: calc(-9% + 6px);
            top: calc(41% - 6px);
            z-index: 0;
            transform: rotateZ(33deg);
        }
    }

    &:nth-child(7) {
        --counter: 3;

        grid-column: #{2 + 2 - 1} / span 3;
        grid-row: calc(var(--counter) + var(--counter) - 1) / span 2;

        &::after {
            content: '';
            width: 6px;
            height: 80%;
            background: #fff;
            position: absolute;
            left: 50%;
            top: -9%;
            z-index: 0;
        }
    }

    &.inactive {
        &::after {
            @apply opacity-0;
        }

        .toggle-team {
            @apply bg-blue-100;
        }

        .hex-grid__inner-content {
            @apply opacity-50 pointer-events-none select-none;
        }

        .toggle-team__icon {
            @apply text-blue-500;

            &::before {
                content: '\e90d';
            }
        }
    }
}

.hex-grid__content {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    background-color: #fff;
    overflow: hidden;
    // clip-path: polygon(75% 0, 100% 50%, 75% 100%, 25% 100%, 0 50%, 25% 0);
    clip-path: url(#hexagon-clip);
    z-index: 1;
}

.hex-grid__inner-content {
    @apply transition duration-300;

    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    padding: 2.5rem 20%;
}

.toggle-team {
    @apply absolute top-0 -mt-2 w-10 h-10 bg-orange-200 rounded-full outline-none;

    right: 20%;

    &:focus {
        @apply outline-none;
    }

    .toggle-team__icon {
        @apply text-orange-400 font-semibold text-xxs;

        &::before {
            content: '\E90B';
        }
    }
}

.toggle-team-info {
  @apply absolute top-0 -mt-2 w-10 h-10 bg-gray-200 rounded-full outline-none;

  right: 20%;

  &:focus {
    @apply outline-none;
  }

  .toggle-team__icon {
    @apply text-blue-500 font-semibold text-xs;
  }
}
</style>
